/**
 * @generated SignedSource<<96ac840b5054c20e5a1c976d882daf82>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductVideo_viewer$data = {
  readonly vimeoItemsVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideoRefetch_viewer">;
  readonly " $fragmentType": "ProductVideo_viewer";
};
export type ProductVideo_viewer$key = {
  readonly " $data"?: ProductVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductVideo_viewer",
  "selections": [
    {
      "alias": "vimeoItemsVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoItemsVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductVideoRefetch_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b280bf4e106babeee8d0595f6b5f95cd";

export default node;
